
import capitalize from '@/mixins/capitalize'
import { mapState } from 'vuex'
import auth from '@/mixins/forms/auth'
export default {
    layout: 'empty',

    middleware: 'auth',

    auth: 'guest',

    mixins: [auth, capitalize],

    data() {
        return {
            loading: false,
            isVendor: false,
        }
    },

    computed: {
        ...mapState({
            globalTexts: (state) => state.jsonloader.data['global.json'] || null,
        }),

        title() {
            return (this.isVendor ? this.globalTexts?.loginVendor?.title : this.globalTexts?.login?.title) || 'Welcome Back!'
        },
        submitLabel() {
            return (this.isVendor ? this.globalTexts?.loginVendor?.button : this.globalTexts?.login?.button) || 'Sign in'
        },
        subHeading() {
            if (this.isStyleQuiz) {
                return 'Sign in to see your results.'
            } else if (this.product?.id) {
                return 'Login to complete your payment.'
            } else {
                return this.isVendor ? this.globalTexts?.loginVendor?.subtitle : this.globalTexts?.login?.subtitle
            }
        },
    },

    created() {
        this.isVendor = [true, 'true'].includes(this.$route.query.vendor)
    },

    methods: {
        async loginPassword() {
            try {
                if (this.$gtag && this.$gtag.event) this.$gtag.event('login', { method: 'Google', event_label: 'modal' })
                this.loading = true
                const response = await this.$store.dispatch('user/loginPassword', { username: this.model.email, password: this.model.password })
                this.initApp(response)
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(`Error during sign in.`, e)
            } finally {
                this.loading = false
            }
        },
    },
}
